import { WebAPI } from "../constants";
import AuthService from "../../common/AuthService";
import download, { ICallbackParams } from "./downloadCommon";

export interface IDownloadConfFileParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 設定ファイルの種類
   */
  type: string;
  /**
   * 作成ファイル名
   */
  filename: string;
}

/**
 * 設定ファイルをダウンロードします
 * @function downloadConfFile
 * @param {IDownloadConfFileParams} params - 設定ファイルダウンロードパラメータ
 */
export function downloadConfFile(params: IDownloadConfFileParams): void {
  const { authService, projectid, type, filename } = params;
  const url = WebAPI.DOWNLOAD_CONFFILE(projectid, type);
  download(url, filename, params, authService);
}
